import React from 'react';
import {useStyles, getDate} from './helper';

const EventItem = ({item}) => {
    const {description, event_date, login, ip} = item;
    const classes = useStyles();
    
    return (
        <div className={classes.root}>
            <span className={classes.date}>{getDate(event_date)}</span>
            <span>{login} ({ip})</span>
            <span className={classes.description}>{description}</span>
        </div>
    )
}

export default EventItem;